var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInkafarmaMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inkafarma-mobile",
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 26C44.8926 33.2092 39.0909 39.1077 32 38.9985C24.9091 39.1077 19 33.3185 19 26C19.1074 18.7908 24.9091 12.8923 32 13.0015C39.0909 12.8923 45 18.6815 45 26Z",
    fill: "#1B8F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7038 23.1596H37.803V20.2104H34.9021V17.3704H29.1005V20.3196H26.1997V23.2688H23.2988V29.0581H26.1997V32.0073H29.1005V34.9565H34.9021V32.0073H37.803V29.0581H40.7038V23.1596Z",
    fill: "#FFF200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3049 24.58H36.4041V21.6308H33.5033V18.7908H30.6024V21.74H27.7016V24.6892H24.8008V27.6385H27.7016V30.5877H30.6024V33.4277H33.5033V30.5877H36.4041V27.6385H39.3049V24.58Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4046 24.5796H33.5038V21.6304H30.603V24.5796H27.7021V27.5288H30.603V30.4781H33.5038V27.5288H36.4046V24.5796Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkafarmaMobile);
export default __webpack_public_path__ + "static/media/inkafarma_mobile.eb7f5dd39991eebd809d6dc2e47a195c.svg";
export { ForwardRef as ReactComponent };